import React, { useState, useEffect } from 'react';
import { Tabs } from '../../../../app/components/Tabs';
import Card from '../../../../app/components/Card';
import { Button } from '../../../../app/components/Button';
import FormAddMySequence from '../../../../forms/FormMySequence/FormAddMySequence';
import { useNavigate } from 'react-router-dom';
import Toast from '../../../../app/components/Toast';
import { usePageTitle } from '../../../../contexts/PageTitleContext';

const MySequences = () => {
  const navigate = useNavigate();
  const { setTitle } = usePageTitle();

  useEffect(() => {
    setTitle('Minhas Sequências');
  }, [setTitle]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [sequencesByCategory, setSequencesByCategory] = useState({});
  const [activeTab, setActiveTab] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    if (activeTab) {
      sessionStorage.setItem('lastActiveTab', activeTab);
    }
  }, [activeTab]);

  const refreshDepartments = () => {
    const storedDepartments = JSON.parse(localStorage.getItem('departments')) || [];
    const storedSequences = JSON.parse(localStorage.getItem('sequencesByCategory')) || {};

    const sequencesMap = storedDepartments.reduce((acc, dep) => {
      acc[dep.nome] = storedSequences[dep.nome] || [];
      return acc;
    }, {});

    setDepartments(storedDepartments);
    setSequencesByCategory(sequencesMap);

    if (storedDepartments.length > 0) {
      const lastSaved = sessionStorage.getItem('lastActiveTab');
      const exists = storedDepartments.find((d) => d.nome === lastSaved);
      setActiveTab(exists ? exists.nome : storedDepartments[0].nome);
    } else {
      setActiveTab('');
    }
  };

  useEffect(() => {
    refreshDepartments();

    const handleStorageChange = (event) => {
      if (event.key === 'departments') {
        refreshDepartments();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const handleOpenModal = () => {
    refreshDepartments();
    setIsModalOpen(true);
  };

  const handleAddSequence = (formData) => {
    const newSequence = {
      id: Date.now().toString(),
      title: formData.nomeSequencia,
      department: formData.departamento,
      description: 0,
    };

    const updatedSequences = {
      ...sequencesByCategory,
      [formData.departamento]: [
        ...(sequencesByCategory[formData.departamento] || []),
        newSequence,
      ],
    };

    setSequencesByCategory(updatedSequences);
    localStorage.setItem('sequencesByCategory', JSON.stringify(updatedSequences));

    setIsModalOpen(false);
    setActiveTab(formData.departamento);
    setToastMessage('Sequência criada com sucesso!');
    setShowToast(true);

    setTimeout(() => setShowToast(false), 3000);
  };

  const renderCards = () => {
    if (departments.length === 0) {
      return (
        <div className="text-center text-gray-500 text-sm pt-24">
          <span className="font-medium">Nenhum departamento cadastrado ainda.</span><br />
          Vá até a aba “Departamentos" em "Cadastros" e cadastre pelo menos um.
        </div>
      );
    }

    if (sequencesByCategory[activeTab]?.length === 0) {
      return (
        <div className="text-center text-gray-500 text-sm pt-24">
          <span className="font-medium">Nenhuma sequência cadastrada neste departamento.</span><br />
          Adicione uma sequência para começar.
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 w-full">
        {sequencesByCategory[activeTab].map((sequence, index) => (
          <Card
            key={`${sequence.title}-${index}`}
            id={sequence.id}
            title={sequence.title}
            onClick={() =>
              navigate(`/detalhes-sequencia?id=${sequence.id}&tab=Lista`, {
                state: { sequenceTitle: sequence.title },
              })
            }
            department={sequence.department}
            amount={sequence.description}
            variant="primary"
          />
        ))}
      </div>
    );
  };

  return (
    <>
      <div className="container mx-auto">
        <div className="flex flex-col mb-8">
          <div className="flex mb-6">
            <Button onClick={handleOpenModal}>Nova Sequência</Button>
          </div>

          {departments.length > 0 && (
            <div className="w-full flex flex-col items-center mb-8">
              <Tabs
                align="left"
                tabsName={departments.map((d) => d.nome)}
                activeTabName={activeTab}
                onTabClick={setActiveTab}
              />
            </div>
          )}

          {renderCards()}
        </div>
      </div>

      {showToast && (
        <Toast type="success" message={toastMessage} />
      )}

      <FormAddMySequence
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleAddSequence}
        activeTab={activeTab}
        departments={departments}
      />
    </>
  );
};

export default MySequences;
